export default "__VITE_ASSET__Bxd81je8__"